<template lang='pug'>
section
  v-card
    v-toolbar(flat color='white')
      h2(class='title font-weight-medium') Менеджеры отдела
      v-spacer
      v-btn(@click='managersDialog = true' small flat)
        v-icon(left) add
        | Добавить менеджера
      s-sort-button(@click='sorting.opened = true' class='mr-3')
    v-divider
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer'  @click='onEdit(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Сорт') {{ props.item.sort_number }}
          td(data-label='ФИО')
            | {{ props.item.second_name }}
            | {{ props.item.first_name }}
            | {{ props.item.patronymic_name }}
          td(data-label='Должность') {{ props.item.position }}
          td(data-label='Телефон') {{ props.item.phone }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(@click.stop='onDelete(props.item.id)' icon)
              v-icon(small) delete_outline
  s-link-managers(
    :multiple='true'
    :dialog='managersDialog'
    @select='onAdd'
    @close='managersDialog = false'
  )
  s-sorting-list(
    v-model='sorting'
    :collection='list'
    @sort-success='fetchList'
    @sort-request='sortManagers'
  )
</template>

<script>
import http from '@/http'

export default {
  props: ['departmentId'],

  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Сорт',
        align: 'left',
        value: 'sort_number',
        width: '0%',
        sortable: true
      },
      {
        text: 'ФИО',
        align: 'left',
        value: 'second_name',
        width: '33%',
        sortable: true
      },
      {
        text: 'Должность',
        align: 'left',
        value: 'position',
        width: '33%',
        sortable: true
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'position',
        width: '33%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    managersDialog: false,
    isLoading: false,
    list: [],
    sorting: {
      opened: false,
      itemValue: 'id',
      itemText: 'second_name',
      renderFn(item) {
        return item.second_name + ' ' + item.first_name + ' ' + item.patronymic_name + ', ' + item.position
      }
    }
  }),

  created() {
    this.fetchList()
  },

  methods: {
    async onAdd(managers) {
      this.managersDialog = false

      try {
        await this.addToDepartment({
          managers,
          id: this.departmentId
        })

        this.fetchList()
      } catch (e) {
        this.$root.showSnack('Не удалось добавить менеджера в отдел')
      }
    },

    async onDelete(id) {
      if (await this.$confirm('Удалить менеджера?')) {
        try {
          await this.removeFromDepartment({
            managers: [id],
            id: this.departmentId
          })

          this.fetchList()
        } catch (e) {
          this.$root.showSnack('Не удалось удалить менеджера из отдела')
        }
      }
    },

    async fetchList() {
      this.isLoading = true

      try {
        this.list = (await http.get('/admin/managers', {
          params: {
            department_id: this.departmentId
          }
        })).data.data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список менеджеров')
      }

      this.isLoading = false
    },

    addToDepartment({ id, managers }) {
      return http.post(`/admin/departments/${id}/manager/add`, {
        managers: managers.map(m => m.id)
      })
    },

    removeFromDepartment({ id, managers }) {
      return http.post(`/admin/departments/${id}/manager/delete`, {
        managers
      })
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.Managers.Edit',
        params: {
          id
        }
      })
    },    
    async sortManagers(ids) {
      try {
        await http.post(`/admin/departments/${this.departmentId}/managers/sort-ref`, { sort_ids: ids })
      } catch(error) {
        this.$root.showSnack('Ошибка сортировки')
      }
    }
  }
}
</script>
